import { Component, OnInit } from '@angular/core';
import { UserService } from '../../apiclient';
import { UserSessionService } from '../../UserSession/user-session.service';
import { LocalDataSource } from 'ng2-smart-table';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { UsuariosActionsCellComponent } from './usuarios.actions.cell.component';

/**
 * Componente que renderiza el listado de usuarios
 */
@Component({
  selector: 'ngx-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {

  settings = {
    actions: {
      delete: false,
      add: false,
      edit:false,
      position: 'right',
  },
    /*
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    */
    columns: {
      id: {
        title: 'ID',
        type: 'number',
      },
      name: {
        title: 'Nombre',
        type: 'string',
      },
      surname: {
        title: 'Apellidos',
        type: 'string',
      },
      email: {
        title: 'Email',
        type: 'string',
      },
      phone: {
        title: 'Teléfono',
        type: 'string',
      },
      company: {
        title: 'Compañia',
        type: 'string',
        valuePrepareFunction: (userCompany) => {
          return userCompany.name;
      },filterFunction:(value,query) => {

        return value.name.toUpperCase().indexOf(query.toUpperCase()) >= 0;
      }
      },
      acciones: {
        title: '',
        type: 'custom',
        renderComponent: UsuariosActionsCellComponent,
        filter : false,
      }
    },
  };

  source: LocalDataSource = new LocalDataSource();

  constructor(private userSessionService: UserSessionService,
    private userService: UserService ,private route: ActivatedRoute,
    private location: Location ) { }

    /**
     * @ignore
     */
  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      console.log(params.get('company'));
      var idcompany = params.get('company')

        this.userService.usersfromcompany(+idcompany,this.userSessionService.accessToken).subscribe((data=> {
          this.source.load(data);
        }));


    });

  }

  /**
   * Regresa a la página anterior
   */
  back(): void{
    this.location.back()
  }
}
